import * as BsIcons from 'react-icons/bs';

import LaunchpadWidgetWrapper from '../../LaunchpadWidgetWrapper';
import ReactSkeleton from '../../ReactSkeleton';

interface Link {
	id: string;
	label: string;
	path: string;
	isVisible: boolean;
}

interface HeaderIcon {
	name: string;
}

interface AdsAndLeadsWidgetProps {
	widgetDetails?: any;
	editMode?: boolean;
	widgets?: any[];
	setWidgets?: (widgets: any[]) => void;
	setSnackbar?: (snackbar: any) => void;
	t: (key: string) => string;
	defaultWidgetStyles?: any;
	widgetCustomizationData?: any;
	setWidgetCustomizationData?: (data: any) => void;
	widgetFinishStatus?: any;
	setWidgetFinishStatus?: (status: any) => void;
	isInPreviewMode?: boolean;
	editModalInputFields?: any;
	setEditModalInputFields?: (fields: any) => void;
	widgetDrawerThemeSettings?: any;
	handleLinkClick?: any;
	isLoading?: boolean;
	selectLaunchpadSettingsData?: any;
	checkAndAdjustLinkPath?: (params: { linkPath: string; activeSection: string }) => { linkPath: string; useSSO: boolean };
}

const AdsAndLeadsWidget = ({
	widgetDetails,
	editMode = false,
	widgets = [],
	setWidgets = () => {},
	setSnackbar = () => {},
	t,
	defaultWidgetStyles,
	widgetCustomizationData,
	setWidgetCustomizationData = () => {},
	widgetFinishStatus,
	setWidgetFinishStatus = () => {},
	isInPreviewMode,
	editModalInputFields,
	setEditModalInputFields,
	widgetDrawerThemeSettings,
	handleLinkClick = () => {},
	isLoading = false,
	selectLaunchpadSettingsData,
	checkAndAdjustLinkPath = () => ({ linkPath: '', useSSO: false }),
}: AdsAndLeadsWidgetProps) => {
	const iconName =
		(isInPreviewMode
			? widgetCustomizationData?.headerIcon
			: defaultWidgetStyles?.headerIcon
		)?.name || 'BsMegaphone';
	const IconComponent = (BsIcons as any)[iconName] || BsIcons.BsMegaphone;

	return (
		<LaunchpadWidgetWrapper
			defaultWidgetStyles={defaultWidgetStyles}
			editModalInputFields={editModalInputFields}
			editMode={editMode}
			handleLinkClick={handleLinkClick}
			headerDescription={
				isInPreviewMode
					? widgetCustomizationData?.headerTitleDescription
					: defaultWidgetStyles?.headerTitleDescription
			}
			headerIcon={
				<IconComponent
					size={32}
					style={{
						color: isInPreviewMode
							? widgetCustomizationData?.iconColor
							: defaultWidgetStyles?.iconColor,
					}}
				/>
			}
			headerText={
				isInPreviewMode
					? widgetCustomizationData?.headerTitle
					: defaultWidgetStyles?.headerTitle
			}
			hideHeader={isLoading}
			iconColor={
				isInPreviewMode
					? widgetCustomizationData?.iconBgColor
					: defaultWidgetStyles?.iconBgColor
			}
			isLoading={isLoading}
			isThemeSelectable
			isTitleBlock
			selectLaunchpadSettingsData={selectLaunchpadSettingsData}
			setEditModalInputFields={setEditModalInputFields}
			setSnackbar={setSnackbar}
			setWidgetCustomizationData={setWidgetCustomizationData}
			setWidgetFinishStatus={setWidgetFinishStatus}
			setWidgets={setWidgets}
			t={t}
			widgetCustomizationData={widgetCustomizationData}
			widgetDetails={widgetDetails}
			widgetDrawerThemeSettings={widgetDrawerThemeSettings}
			widgetFinishStatus={widgetFinishStatus}
			widgets={widgets}
		>
			<div className="bay-widget-body">
				{isLoading ? (
					<>
						<ReactSkeleton.HeaderLayout />
						<div className="mt-3">
							<ReactSkeleton.LinksLayout />
						</div>
					</>
				) : (
					<div className="d-flex flex-column">
						{(isInPreviewMode
							? widgetCustomizationData?.links
							: defaultWidgetStyles?.links
						)?.map((link: Link) => {
							const { linkPath: newLink, useSSO } = checkAndAdjustLinkPath({
								linkPath: link.path,
								activeSection: 'adsAndLeads',
							});
							return (
								link.isVisible && (
									<a
										key={link.id}
										className="text-start p-2 border-0 text-decoration-none fs-6 d-inline-block"
										href={newLink}
										style={{
											color: isInPreviewMode
												? widgetCustomizationData?.linkColor
												: defaultWidgetStyles?.linkColor,
											width: 'fit-content',
										}}
										target="_blank"
										onClick={(e) => handleLinkClick(e, newLink, useSSO)} rel="noreferrer"
									>
										{link.label}
									</a>
								)
							);
						})}
					</div>
				)}
			</div>
		</LaunchpadWidgetWrapper>
	);
};

export default AdsAndLeadsWidget;
